const genders = [{ gender: 'Male' }, { gender: 'Female' }];

export default genders;
